export const canadaWholesaleStats = [
  { value: "CAD $6,000", label: "Minimum Order", icon: "ri-shopping-bag-3-line" },
  { value: "40-60%", label: "Below Retail Price", icon: "ri-percent-line" },
  { value: "400+", label: "Canada Factory Products", icon: "ri-building-2-line" },
  { value: "2-4 Days", label: "Canada Delivery", icon: "ri-truck-line" },
];

export const canadaWholesaleProducts = [
  {
    id: "cwp-001",
    name: "Pure Canadian Maple Syrup Grade A Amber 1L",
    factory: "Quebec Maple Farms Co.",
    location: "Quebec, Canada",
    flag: "🇨🇦",
    retailPrice: 22.99,
    wholesalePrice: 12.50,
    minOrderQty: 480,
    minOrderValue: 6000,
    savings: 46,
    category: "Farm Products",
    inStock: 12000,
    image: "https://public.readdy.ai/ai/img_res/1c5482c089c7ee713ae72ae5b51e4a27.jpg",
    badge: "Canada #1",
    certifications: ["Canada Organic", "Non-GMO", "Grade A"],
  },
  {
    id: "cwp-002",
    name: "Premium Wild Blueberry Jam 500ml",
    factory: "Nova Scotia Berry Works",
    location: "Nova Scotia, Canada",
    flag: "🇨🇦",
    retailPrice: 14.99,
    wholesalePrice: 7.80,
    minOrderQty: 770,
    minOrderValue: 6006,
    savings: 48,
    category: "Farm Products",
    inStock: 9500,
    image: "https://readdy.ai/api/search-image?query=premium%20wild%20blueberry%20jam%20500ml%20glass%20jar%20with%20purple%20label%20and%20blueberries%20scattered%20around%20on%20white%20background%2C%20artisan%20canadian%20farm%20product%20photography%2C%20professional%20studio%20lighting%2C%20deep%20purple%20color%2C%20natural%20rustic%20packaging&width=400&height=280&seq=cwp002&orientation=landscape",
    badge: "Wild Harvested",
    certifications: ["Canada Organic", "Non-GMO"],
  },
  {
    id: "cwp-003",
    name: "Insulated Cedar Wood Raised Garden Bed 4x8ft",
    factory: "BC Timber Craft Ltd.",
    location: "British Columbia, Canada",
    flag: "🇨🇦",
    retailPrice: 119.99,
    wholesalePrice: 68.50,
    minOrderQty: 88,
    minOrderValue: 6028,
    savings: 43,
    category: "Garden",
    inStock: 1800,
    image: "https://readdy.ai/api/search-image?query=premium%20cedar%20wood%20raised%20garden%20bed%204x8%20feet%20assembled%20outdoors%20with%20soil%20and%20green%20plants%2C%20product%20photography%2C%20clean%20white%20background%2C%20professional%20studio%20lighting%2C%20natural%20wood%20grain%20finish%2C%20canadian%20timber%20quality&width=400&height=280&seq=cwp003&orientation=landscape",
    badge: "Canadian Cedar",
    certifications: ["FSC Certified", "Made in Canada"],
  },
  {
    id: "cwp-004",
    name: "Cold-Pressed Canola Oil 4L Jug",
    factory: "Prairie Gold Oils Inc.",
    location: "Saskatchewan, Canada",
    flag: "🇨🇦",
    retailPrice: 19.99,
    wholesalePrice: 10.80,
    minOrderQty: 556,
    minOrderValue: 6005,
    savings: 46,
    category: "Farm Products",
    inStock: 7200,
    image: "https://readdy.ai/api/search-image?query=cold%20pressed%20canola%20oil%204%20liter%20clear%20plastic%20jug%20with%20yellow%20label%20on%20white%20background%2C%20canadian%20farm%20product%20photography%2C%20professional%20studio%20lighting%2C%20golden%20yellow%20oil%2C%20prairie%20canada%20product%2C%20clean%20minimal%20packaging&width=400&height=280&seq=cwp004&orientation=landscape",
    badge: "Prairie Gold",
    certifications: ["Canada Organic", "Non-GMO", "Heart Healthy"],
  },
  {
    id: "cwp-005",
    name: "Merino Wool Throw Blanket 50x60in",
    factory: "Alberta Wool Weavers",
    location: "Alberta, Canada",
    flag: "🇨🇦",
    retailPrice: 79.99,
    wholesalePrice: 44.50,
    minOrderQty: 135,
    minOrderValue: 6008,
    savings: 44,
    category: "Home Goods",
    inStock: 3200,
    image: "https://readdy.ai/api/search-image?query=premium%20merino%20wool%20throw%20blanket%2050x60%20inches%20folded%20neatly%20on%20white%20background%2C%20luxury%20home%20goods%20product%20photography%2C%20professional%20studio%20lighting%2C%20natural%20cream%20and%20grey%20colors%2C%20soft%20texture%20visible%2C%20canadian%20wool%20quality&width=400&height=280&seq=cwp005&orientation=landscape",
    badge: "Merino Wool",
    certifications: ["Made in Canada", "Woolmark Certified"],
  },
  {
    id: "cwp-006",
    name: "Beeswax Lip Balm Set 12-Pack",
    factory: "Ontario Bee Naturals",
    location: "Ontario, Canada",
    flag: "🇨🇦",
    retailPrice: 4.99,
    wholesalePrice: 2.40,
    minOrderQty: 2500,
    minOrderValue: 6000,
    savings: 52,
    category: "Beauty",
    inStock: 45000,
    image: "https://readdy.ai/api/search-image?query=natural%20beeswax%20lip%20balm%20set%2012%20pack%20tubes%20in%20kraft%20paper%20packaging%20on%20white%20background%2C%20natural%20beauty%20product%20photography%2C%20professional%20studio%20lighting%2C%20honey%20yellow%20and%20brown%20colors%2C%20organic%20canadian%20beeswax%2C%20minimal%20eco%20packaging&width=400&height=280&seq=cwp006&orientation=landscape",
    badge: "All Natural",
    certifications: ["Canada Organic", "Cruelty-Free", "Vegan"],
  },
];

export const canadaWholesaleTiers = [
  {
    name: "Bronze",
    minOrder: 6000,
    maxOrder: 14999,
    currency: "CAD",
    discount: "Up to 40% off retail",
    perks: ["Wholesale pricing", "Priority shipping", "Dedicated account manager"],
    color: "from-amber-700 to-amber-500",
    textColor: "text-amber-700",
    bgColor: "bg-amber-50",
    borderColor: "border-amber-200",
    popular: false,
  },
  {
    name: "Silver",
    minOrder: 15000,
    maxOrder: 49999,
    currency: "CAD",
    discount: "Up to 50% off retail",
    perks: ["All Bronze perks", "Net-30 payment terms", "Custom labeling available", "Free freight on orders CAD $20K+"],
    color: "from-gray-500 to-gray-400",
    textColor: "text-gray-600",
    bgColor: "bg-gray-50",
    borderColor: "border-gray-300",
    popular: false,
  },
  {
    name: "Gold",
    minOrder: 50000,
    maxOrder: null,
    currency: "CAD",
    discount: "Up to 60% off retail",
    perks: ["All Silver perks", "Exclusive product lines", "White-label / OEM options", "Dedicated logistics team", "Net-60 payment terms"],
    color: "from-[#D4AF37] to-[#B8860B]",
    textColor: "text-[#B8860B]",
    bgColor: "bg-[#fdf8f0]",
    borderColor: "border-[#D4AF37]/50",
    popular: true,
  },
];

export const canadaWholesaleCategories = [
  {
    id: "cwc-001",
    name: "Farm & Food",
    icon: "ri-seedling-line",
    productCount: 218,
    minOrder: 6000,
    image: "https://readdy.ai/api/search-image?query=bulk%20wholesale%20canadian%20farm%20food%20products%20maple%20syrup%20blueberry%20jam%20canola%20oil%20stacked%20cases%20in%20warehouse%2C%20professional%20product%20photography%2C%20canadian%20farm%20products%2C%20organized%20bulk%20inventory%2C%20clean%20background&width=400&height=300&seq=cwcat1&orientation=landscape",
  },
  {
    id: "cwc-002",
    name: "Garden & Outdoor",
    icon: "ri-plant-line",
    productCount: 156,
    minOrder: 6000,
    image: "https://readdy.ai/api/search-image?query=bulk%20wholesale%20canadian%20cedar%20garden%20beds%20outdoor%20products%20stacked%20in%20warehouse%2C%20professional%20product%20photography%2C%20canadian%20made%20garden%20supplies%2C%20organized%20bulk%20inventory%2C%20clean%20background&width=400&height=300&seq=cwcat2&orientation=landscape",
  },
  {
    id: "cwc-003",
    name: "Home Goods",
    icon: "ri-home-4-line",
    productCount: 189,
    minOrder: 6000,
    image: "https://readdy.ai/api/search-image?query=bulk%20wholesale%20canadian%20home%20goods%20wool%20blankets%20candles%20kitchen%20products%20stacked%20in%20warehouse%2C%20professional%20product%20photography%2C%20clean%20background%2C%20organized%20bulk%20inventory&width=400&height=300&seq=cwcat3&orientation=landscape",
  },
  {
    id: "cwc-004",
    name: "Beauty & Wellness",
    icon: "ri-heart-pulse-line",
    productCount: 134,
    minOrder: 6000,
    image: "https://readdy.ai/api/search-image?query=bulk%20wholesale%20canadian%20natural%20beauty%20wellness%20products%20beeswax%20lip%20balm%20skincare%20stacked%20boxes%20in%20warehouse%2C%20professional%20product%20photography%2C%20clean%20background%2C%20organized%20bulk%20inventory&width=400&height=300&seq=cwcat4&orientation=landscape",
  },
];
